import { render, staticRenderFns } from "./le-switch-btn.vue?vue&type=template&id=4c834fb0&scoped=true&"
import script from "./le-switch-btn.vue?vue&type=script&lang=js&"
export * from "./le-switch-btn.vue?vue&type=script&lang=js&"
import style0 from "./le-switch-btn.vue?vue&type=style&index=0&id=4c834fb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c834fb0",
  null
  
)

export default component.exports